import { Component, Input } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TranslateModule } from '@ngx-translate/core';

import { FlexModule } from '@angular/flex-layout';
import { IProblemsDetailed } from '../../../../../../../interfaces/Problems/IProblemsDetailed';

@Component({
  selector: 'app-resolved-problems-expand',
  standalone: true,
  templateUrl: './resolved-problems-expand.component.html',
  styleUrls: ['./resolved-problems-expand.component.css'],
  imports: [NzLayoutModule, NzTableModule, TranslateModule, FlexModule],
})
export class ResolvedProblemsExpandComponent {
  @Input() item: IProblemsDetailed = {};
}
